<template>
	<button class="element-TextButton text-button" :disabled="disabled" @click="click">
		<slot />
	</button>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		autofocus: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	mounted() {
		if (this.autofocus) {
			this.$el.focus()
		}
	},
	methods: {
		click(e) {
			this.$emit('click', e)
		},
	},
}
</script>

<style scoped lang="scss">
$element-TextButton-font: $body-font !default;
$element-TextButton-background: $color-primary !default;
$element-TextButton-hover-background: $color-primary !default;
$element-TextButton-disabled-background: #cdcdcd !default;
$element-TextButton-radius: 0 !default;
$element-TextButton-border: none !default;
$element-TextButton-padding: 10px 25px !default;
$element-TextButton-color: white !default;

.text-button {
	font: $element-TextButton-font;
	border: $element-TextButton-border;
	background: $element-TextButton-background;
	border-radius: $element-TextButton-radius;
	padding: $element-TextButton-padding;
	color: $element-TextButton-color;
	cursor: pointer;

	/* make the text unselectable */
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.text-button:focus {
	outline-offset: 3px;
}

.text-button:hover {
	background: $element-TextButton-hover-background;
}

.text-button:disabled,
.text-button:hover:disabled {
	background: $element-TextButton-disabled-background;
}
</style>
